import { render, staticRenderFns } from "./kolLayout.vue?vue&type=template&id=b4299e50&scoped=true"
import script from "./kolLayout.vue?vue&type=script&lang=js"
export * from "./kolLayout.vue?vue&type=script&lang=js"
import style0 from "./kolLayout.vue?vue&type=style&index=0&id=b4299e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4299e50",
  null
  
)

export default component.exports